import gql from 'graphql-tag';

/**
 * Keycode Validation Query
 */
export const VALIDATE_KEYCODE = gql`
	query validateKeyCode($keyCode: String!, $variantId: Int!) {
		validateKeyCode(keyCode: $keyCode, variantId: $variantId) {
			code
		}
	}
`;
